import '@/config/firebase';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { pdfjs } from 'react-pdf';
import { v4 as uuidv4 } from 'uuid';
import { registerSW } from 'virtual:pwa-register';

import App from '@/App';
import DetectDevice from '@/components/DetectDevice';
import '@/i18n';
import { resolveInitialTheme } from '@/theme/themes';
import Wrapper from '@/Wrapper';
import './index.css';

document.documentElement.dataset.theme = resolveInitialTheme();

// import '@/demos/ipc';

if (import.meta.env.DEV) {
  const module = await import('./mocks/browser');
  const worker = module.default;
  await worker.start({
    serviceWorker: {
      url: `${window.location.origin}/mockServiceWorker.js`,
    },
  });
}
const updateSW = registerSW({
  async onNeedRefresh() {
    // eslint-disable-next-line no-alert
    const shouldUpdate = window.confirm('A new version is available. Do you want to update?');
    if (shouldUpdate) {
      await updateSW();
    }
  },
});

if (!localStorage.getItem('device-id')) {
  const deviceId = uuidv4();
  localStorage.setItem('device-id', deviceId);
}

const isElectron = !!(window as { electronAPI?: unknown }).electronAPI;
const isPackaged = window.location.protocol === 'file:';

if (isElectron && isPackaged) {
  const appPath = window.location.pathname.replace(/\/[^/]*$/, '');
  pdfjs.GlobalWorkerOptions.workerSrc = `file://${appPath}/resources/pdf.worker.mjs`;
} else {
  pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.mjs';
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      gcTime: 0,
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      staleTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

const container = document.querySelector('#root');
if (container) {
  const root = createRoot(container);
  root.render(
    // <StrictMode>
    <Wrapper>
      <QueryClientProvider client={queryClient}>
        <DetectDevice>
          <App />
        </DetectDevice>
      </QueryClientProvider>
    </Wrapper>,
    // {/* </StrictMode>, */}
  );
}
